import React, { useMemo } from "react";

type AuthTransitionScreenProps = {
  message?: string;
};

function readTransitionTheme(): "light" | "dark" {
  try {
    for (const key of ["theme", "vision-guard-theme", "variphi-theme"] as const) {
      const stored = localStorage.getItem(key);
      if (stored === "light" || stored === "dark") return stored;
    }
    const match = document.cookie.match(/(?:^|;\s*)variphi-theme=(light|dark)/);
    if (match?.[1] === "light" || match?.[1] === "dark") return match[1];
  } catch {
    // ignore
  }
  return document.documentElement.classList.contains("dark") ? "dark" : "light";
}

export function AuthTransitionScreen({ message }: AuthTransitionScreenProps) {
  const isDark = useMemo(() => readTransitionTheme() === "dark", []);
  const logoSrc = isDark ? "/logo.png" : "/logo-black.png";
  const bg = isDark ? "#0c1018" : "#f3f4f6";
  const track = isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.08)";
  const head = isDark ? "#e5e7eb" : "#009661";

  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center gap-7"
      style={{ background: bg }}
    >
      <img
        src={logoSrc}
        alt="Niadit"
        decoding="async"
        className="h-[42px] w-auto opacity-95"
      />
      <div
        className="h-8 w-8 animate-spin rounded-full border-2"
        style={{ borderColor: track, borderTopColor: head }}
        role="status"
        aria-label="Loading"
      />
      {message ? (
        <p
          className="text-sm"
          style={{ color: isDark ? "#94a3b8" : "#64748b" }}
        >
          {message}
        </p>
      ) : null}
    </div>
  );
}

export default AuthTransitionScreen;
